const removeFirstLineFromHtml = (contentState) => {
    if (contentState) {
        if (typeof (contentState.blocks[0].text) !== 'undefined' && contentState.blocks[0].text === '') {
            delete contentState.blocks[0];
            const reindex_editorState_blocks = contentState.blocks.filter((element) => typeof (element) !== 'undefined');
            contentState.blocks = reindex_editorState_blocks;
        }
    }

    return contentState;
};

export default removeFirstLineFromHtml;
